//CTA AFTER SCROLL
var floatingCtaButton = document.querySelector(".floating-mobile-cta");


window.addEventListener("scroll", () => {
    var y = window.scrollY;
    if (y >= 400) {
        floatingCtaButton.classList.add("show");
    } else {
        floatingCtaButton.classList.remove("show");
    }
});

// CHECKOUT POPUP START

const intakeStep2BTN = document.querySelector('#btn-step-2');


intakeStep2BTN.addEventListener("click", function() {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
});





// document.addEventListener('DOMContentLoaded', function() {

// if (document.querySelector('.checkout-popup')) {

//   const checkoutPopupCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith('checkoutPopup='));
  
  
//   let showCheckoutPopup = true;
  
  
//   if (checkoutPopupCookie) {
//       showCheckoutPopup = false;
//   }
  
  
//   console.log("NICKRAT checkoutPopup cookie: " + showCheckoutPopup); 

  
  
//   const headerMenuItem = document.querySelector('.list-menu');
//   // const headerMenuItem = document.querySelector('.header__menu-item');
//   const headerSiteLogo = document.querySelector('.header__heading-link');
//     const checkoutPopup = document.querySelector('.checkout-popup');
// const checkoutPopupClose = document.querySelector('.checkout-popup-close');
// const checkoutPopupOverlay = document.querySelector('.checkout-popup-overlay');




  
//       if(showCheckoutPopup === true) {

        
//         //  $(document).mouseleave(function () {
//         //    checkoutPopup.style.display = 'block';
//         //   document.cookie = "checkoutPopup=true";
//         //   // showCheckoutPopup = false;
//         // });

//           // headerMenuItem.addEventListener('mouseenter', headerPopupEvent);
//           // headerSiteLogo.addEventListener('mouseenter', headerPopupEvent);
//           headerMenuItem.addEventListener('click', headerPopupEvent);
//           headerSiteLogo.addEventListener('click', headerPopupEvent);


//           // document.addEventListener('mouseleave', headerPopupEvent);


// document.addEventListener('mouseleave', offScreenEvent);
// function offScreenEvent() {
    
//     if (event.clientY <= 0 || event.clientX <= 0 || (event.clientX >= window.innerWidth || event.clientY >= window.innerHeight)) {
        
//         headerPopupEvent();
//     }
// };

  

        

//           if (window.innerWidth <= 767) {
//             window.addEventListener("beforeunload", headerPopupEvent);



//             window.addEventListener("focus", mobileLeaveWindowEvent);
//             function mobileLeaveWindowEvent() {
//                 if (event.target === window) {
//                     headerPopupEvent();
//                 }
//             };


//           }


        
//           function headerPopupEvent() {
//             event.preventDefault();           


//             checkoutPopup.style.display = 'block';

//             document.cookie = "checkoutPopup=true";
//             console.log("NICKRAT showCheckoutPopup: " + showCheckoutPopup); 
//             // showCheckoutPopup = false;
//             console.log("NICKRAT showCheckoutPopup: " + showCheckoutPopup); 
//             // headerMenuItem.removeEventListener('mouseenter', headerPopupEvent);
//             // headerSiteLogo.removeEventListener('mouseenter', headerPopupEvent);
//             headerMenuItem.removeEventListener('click', headerPopupEvent);
//             headerSiteLogo.removeEventListener('click', headerPopupEvent);
//             document.removeEventListener('mouseleave', headerPopupEvent);
//             window.removeEventListener("beforeunload", headerPopupEvent);

//             document.removeEventListener('mouseleave', offScreenEvent);

//             window.removeEventListener("focus", mobileLeaveWindowEvent);
//           };


//         // headerSiteLogo.addEventListener('mouseenter', logoPopupEvent);
//         //     function logoPopupEvent() {
//         //       checkoutPopup.style.display = 'block';
//         //       document.cookie = "checkoutPopup=true";
//         //       console.log("NICKRAT LOGO HOVER"); 
//         //       // showCheckoutPopup = false;
//         //       headerSiteLogo.removeEventListener('mouseenter', logoPopupEvent);
//         //   };

//       }
      
    

//     checkoutPopupClose.addEventListener('click', function() {
//         checkoutPopup.style.display = 'none';
//     });

//  checkoutPopupOverlay.addEventListener('click', function() {
//         checkoutPopup.style.display = 'none';
//     });

//     // headerMenuItem.addEventListener('mouseleave', function() {
//     //     checkoutPopup.style.display = 'none';
//     // });

// }
  
// });

// CHECKOUT POPUP END










document.addEventListener('DOMContentLoaded', function() {
    console.log("NICKRAT DOM is ready"); 
});










// UTM CODE START




function extractParametersAndSetCookie() {
    
    var urlParams = new URLSearchParams(window.location.search);
    console.log("NICKRAT urlParams: " + urlParams);
    
    
    if (urlParams.toString() !== '') {
       
        var paramString = urlParams.toString();
      console.log("NICKRAT paramString: " + paramString);
        
        
        document.cookie = "urlParameters=" + encodeURIComponent(paramString) + "; expires=" + new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toUTCString() + "; path=/";
    }

  addParamsToForm();
}


//window.addEventListener('load', extractParametersAndSetCookie);










// document.addEventListener('DOMContentLoaded', function() {
function addParamsToForm() {
    
    var urlParamsCookie = getCookie('urlParameters');
    console.log('NICKRAT urlParamsCookie: ' + urlParamsCookie);
    
    if (urlParamsCookie && document.getElementById('urlparams')) {
        document.getElementById('urlparams').value = urlParamsCookie;
    }
// });
}


function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return '';
}








  
// UTM CODE END









// Wait for the document to load
document.addEventListener("DOMContentLoaded", function() {
    console.log('NICKRAT right here');
    // Find the element with the ID "billing_address_selector"
    var billingAddressSelector = document.getElementById("billing_address_selector");
    
    // Check if the element exists
    if (billingAddressSelector) {
        // Create the new HTML code
        var newHtml = `
            <p class="cart-attribute__field">
                <label for="patient-name">Patient Name</label>
                <input required class="required" id="patient-name" type="text" name="attributes[Patient Name]" value="{{ cart.attributes["Patient Name"] }}">
            </p>
        `;
        
        // Create a new element to contain the HTML code
        var wrapper = document.createElement('div');
        wrapper.innerHTML = newHtml;
        
        // Append the new HTML code after the element with the ID "billing_address_selector"
        billingAddressSelector.parentNode.insertBefore(wrapper.firstChild, billingAddressSelector.nextSibling);
    }
});



















